export default "__VITE_ASSET__8ad0104e__"